import src from "IMAGE";
export default { src, width: 940, height: 550, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAQklEQVR42n2N2w4AIARA+/8P7bbSE68itlZrPRyGg0Cj8o9AULyQDNk4BW+qCOUhSMAWmXpi7NEu3YJuraFI+6UxAf6Ul/VM9hGAAAAAAElFTkSuQmCC"};
